import { render } from "./TDFormContract.vue?vue&type=template&id=08479915"
import script from "./TDFormContract.vue?vue&type=script&lang=js"
export * from "./TDFormContract.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__